import module from 'fan/proyecto/module.js'

export const FanProyectoEsquemasSchema = {
  limite_suministro: 'number',
  id_metodo_calculo_suministro: 'number',
  id_tipo_comision: 'number',
  comision_porcentaje: 'number',
  predeterminado: 'boolean',
  captura_fecha: 'timestamp',
  comisionistas: {
    comision_porcentaje: 'number',
    master: 'boolean',
    id_tipo_comisionista: 'number',
  },
}

export class FanProyectoEsquemasService {
  constructor($http) {
    this.$http = $http
  }

  get(idProyecto) {
    return this.$http.get('/api/proyecto/esquemas', {
      params: {id_proyecto: idProyecto},
      schema: FanProyectoEsquemasSchema,
    })
  }

  post(idProyecto, data) {
    return this.$http.post('/api/proyecto/esquemas', data, {
      params: {id_proyecto: idProyecto},
      schema: FanProyectoEsquemasSchema,
    })
  }
}

module.service('FanProyectoEsquemasService', FanProyectoEsquemasService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Esquemas.js